customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super(),
          this.querySelector("form")
            ? ((this.form = this.querySelector("form")),
              (this.form.querySelector("[name=id]").disabled = !1),
              this.form.addEventListener(
                "submit",
                this.onSubmitHandler.bind(this)
              ))
            : ((this.querySelector("[name=id]").disabled = !1),
              this.querySelector("button[type=submit]").addEventListener(
                "click",
                this.onSubmitHandler.bind(this)
              )),
          (this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer")),
          (this.submitButton = this.querySelector('[type="submit"]')),
          document.querySelector("cart-drawer") &&
            this.submitButton.setAttribute("aria-haspopup", "dialog"),
          (this.hideErrors = "true" === this.dataset.hideErrors);
      }
      onSubmitHandler(e) {
        if (
          (e.preventDefault(),
          "true" !== this.submitButton.getAttribute("aria-disabled"))
        ) {
          this.handleErrorMessage(),
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButton.classList.add("loading"),
            this.querySelector(".loading-overlay__spinner")?.classList.remove(
              "hidden"
            );
          e = fetchConfig("javascript");
          (e.headers["X-Requested-With"] = "XMLHttpRequest"),
            delete e.headers["Content-Type"];
          let r = new FormData(this.form);
          this.form || r.append("id", this.querySelector("[name=id]").value),
            this.cart &&
              (r.append(
                "sections",
                this.cart.getSectionsToRender().map((e) => e.id)
              ),
              r.append("sections_url", window.location.pathname),
              this.cart.setActiveElement(document.activeElement)),
            (e.body = r),
            fetch("" + routes.cart_add_url, e)
              .then((e) => e.json())
              .then((e) => {
                var t;
                if (e.status)
                  return (
                    publish(PUB_SUB_EVENTS.cartError, {
                      source: "product-form",
                      productVariantId: r.get("id"),
                      errors: e.description,
                      message: e.message,
                    }),
                    this.handleErrorMessage(e.description),
                    (t = this.submitButton.querySelector(".sold-out-message"))
                      ? (this.submitButton.setAttribute("aria-disabled", !0),
                        this.submitButton
                          .querySelector("span")
                          .classList.add("hidden"),
                        t.classList.remove("hidden"),
                        void (this.error = !0))
                      : void 0
                  );
                this.cart
                  ? (this.error ||
                      publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: "product-form",
                        productVariantId: r.get("id"),
                      }),
                    (this.error = !1),
                    (t = this.closest("quick-add-modal"))
                      ? (document.body.addEventListener(
                          "modalClosed",
                          () => {
                            setTimeout(() => {
                              this.cart.renderContents(e);
                            });
                          },
                          { once: !0 }
                        ),
                        t.hide(!0))
                      : this.cart.renderContents(e))
                  : (window.location = window.routes.cart_url);
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove("loading"),
                  this.cart &&
                    this.cart.classList.contains("is-empty") &&
                    this.cart.classList.remove("is-empty"),
                  this.error ||
                    this.submitButton.removeAttribute("aria-disabled"),
                  this.querySelector(".loading-overlay__spinner").classList.add(
                    "hidden"
                  );
              });
        }
      }
      handleErrorMessage(e = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !e),
            e) &&
            (this.errorMessage.textContent = e));
      }
    }
  );
